import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AppSettings } from "../../proyect.conf";
import { FlujoVentaPasoRestriccionPerfilVinculacion } from "../_models/flujo-venta-paso-restriccion-perfil-vinculacion";
import { AutenticacionService } from "./autenticacion.service";

@Injectable({
  providedIn: "root",
})
export class FlujoVentaPasoRestriccionPerfilVinculacionService {
  private rutServicio = AppSettings.rutServiciosAPL + "/api/flujoVentaPasosRestriccionesPerfilesVinculaciones";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listado() {
    return this.httpClient
      .get(this.rutServicio)
      .pipe(map((res) => res as FlujoVentaPasoRestriccionPerfilVinculacion[]));
  }

  listadoHabilitados() {
    return this.httpClient
      .get(this.rutServicio + "/enabled")
      .pipe(map((res) => res as FlujoVentaPasoRestriccionPerfilVinculacion[]));
  }

  obtenerPorId(id: string) {
    return this.httpClient
      .get(this.rutServicio + "/" + id)
      .pipe(map((res) => res as FlujoVentaPasoRestriccionPerfilVinculacion));
  }

  listadoPorFlujoVentaPasoListado(listado: string[]) {
    return this.httpClient
      .post(this.rutServicio + '/flujoVenta/idListIn/enabled', listado)
      .pipe(map((res) => res as FlujoVentaPasoRestriccionPerfilVinculacion[]));
  }

  obtenerPorFlujoVentaPaso(idFlujoVentaPaso: string) {
    return this.httpClient
      .get(this.rutServicio + "/flujoVenta/" + idFlujoVentaPaso)
      .pipe(map((res) => res as FlujoVentaPasoRestriccionPerfilVinculacion[]));
  }

  obtenerPorFlujoVentaPasoHabilitado(idFlujoVentaPaso: string) {
    return this.httpClient
      .get(this.rutServicio + "/flujoVenta/" + idFlujoVentaPaso + "/enabled")
      .pipe(map((res) => res as FlujoVentaPasoRestriccionPerfilVinculacion[]));
  }

  crear(regCrear: FlujoVentaPasoRestriccionPerfilVinculacion) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as FlujoVentaPasoRestriccionPerfilVinculacion));
  }

  actualizar(regActualizar: FlujoVentaPasoRestriccionPerfilVinculacion) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as FlujoVentaPasoRestriccionPerfilVinculacion));
  }

  bulk(registros: FlujoVentaPasoRestriccionPerfilVinculacion[]) {
    registros.forEach((e) => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httpClient
      .post(this.rutServicio + '/bulk', registros)
      .pipe(map((res) => res as FlujoVentaPasoRestriccionPerfilVinculacion[]));
  }
}
